import { Action } from '@ngrx/store';
import { WatchListNotificationViewModel, WatchList, WatchListItemNew } from '../models/watch-list.model';
import { Out } from '../models/product-pricing.model'

export enum WatchListActionTypes {
    Update = '[WatchList] Update',
    Delete = '[WatchList] Delete',
    DeleteSuccess = '[WatchList] DeleteSuccess',
    DeleteFailure = '[WatchList] DeleteFailure',
    Load = '[WatchList] Load',
    LoadSuccess = '[WatchList] LoadSuccess',
    LoadFailure = '[WatchList] LoadFailure',
    Insert = '[WatchList] Insert',
    InsertSuccess = '[WatchList] InsertSuccess',
    InsertFailure = '[WatchList] InsertFailure',
}

export class UpdateWatchListItem implements Action {
    readonly type = WatchListActionTypes.Update;
    constructor(public payload: WatchListNotificationViewModel) { }
}

export class DeleteWatchListItem implements Action {
    readonly type = WatchListActionTypes.Delete;
    constructor(public payload: string) { }
}

export class DeleteWatchListItemSuccess implements Action {
    readonly type = WatchListActionTypes.DeleteSuccess;
    constructor(public payload: string) { }
}

export class DeleteWatchListItemFailure implements Action {
    readonly type = WatchListActionTypes.DeleteFailure;
    constructor() { }
}


export class LoadWatchList implements Action {
    readonly type = WatchListActionTypes.Load;

}

export class LoadWatchListSuccess implements Action {
    readonly type = WatchListActionTypes.LoadSuccess;
    constructor(public payload: WatchListItemNew[]) { }
}

export class LoadWatchListFailure implements Action {
    readonly type = WatchListActionTypes.LoadFailure;
    constructor(public payload: string) { }
}

export class InsertWatchListItem implements Action {
    readonly type = WatchListActionTypes.Insert;
    constructor(public payload: Out) { }
}

export class InsertWatchListItemSuccess implements Action {
    readonly type = WatchListActionTypes.InsertSuccess;
    constructor(public payload: WatchListItemNew) { }
}

export class InsertWatchListItemFailure implements Action {
    readonly type = WatchListActionTypes.InsertFailure;
    constructor() { }
}

export type WatchListActions = UpdateWatchListItem | DeleteWatchListItem | LoadWatchList | InsertWatchListItem | LoadWatchListSuccess | LoadWatchListFailure | DeleteWatchListItemSuccess | DeleteWatchListItemFailure | InsertWatchListItemSuccess | InsertWatchListItemFailure;